/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SimpleRouteItem from 'app/components/RouteList/SimpleRouteItem.jsx';
import AdvancedRouteItem from 'app/components/RouteList/AdvancedRouteItem.jsx';
import ListActionButton from 'app/components/common/ListActionButton.jsx';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';

class RouteListComponent extends React.Component {
	constructor(props) {
		super(props);

		let selectedRoute = 0;

		if (this.props.router.params) {
			if (this.props.router.params.routeId) {
				selectedRoute = this.props.router.params.routeId;
			}
		}

		this.state = {
			selectedRoute
		};

		this.showDetailForRoute = this.showDetailForRoute.bind(this);
		this.refreshInput = this.refreshInput.bind(this);
		this.refreshPerms = this.refreshPerms.bind(this);

	}

	componentDidMount() {
		if (this.state.selectedRoute) {
			this.props.getRoute(this.state.selectedRoute);
		}
		this.props.clearFilter('routes');
	}

	/*
	 * Activating or deactivating an input changes what is left on the plan, and
	 * the list draws the remaining counts. There is no registry for inputs yet,
	 * so INPUT_UPDATE is watched in componentDidUpdate.
	 *
	 * The social half lives on Automate, not here: this list only mounts once
	 * ROUTE_LIST has landed, and a reconnect return fires its update at mount,
	 * alongside that fetch — the page is the thing that is always up.
	 */
	refreshPerms() {
		this.props.getUserPerms();
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		let selectedRoute = 0;

		if (nextProps.router.params && nextProps.router.params.routeId) {
			selectedRoute = nextProps.router.params.routeId;
		}

		if (selectedRoute != prevState.selectedRoute) {
			return {
				selectedRoute
			};
		}

		return null;

	}

	componentDidUpdate(prevProps, prevState) {

		if (prevState.selectedRoute !== this.state.selectedRoute && this.state.selectedRoute) {
			this.props.getRoute(this.state.selectedRoute);
		}

		if (prevProps.app.loading.INPUT_UPDATE === true && this.props.app.loading.INPUT_UPDATE === false) {
			this.refreshPerms();
		}

	}

	showDetailForRoute(e) {
		let id = e.currentTarget.dataset.id;

		//second click on row closes the detail
		if (this.state.selectedRoute === id) {
			this.setState({
				selectedRoute: 0
			}, () => {
				this.props.deleteMessage(['ROUTE_CREATE', 'INPUT_UPDATE', 'INPUT_REFRESH']);
				this.props.router.navigate('/share/automate');
			});
		} else {
			this.setState({
				selectedRoute: id
			}, () => {
				this.props.deleteMessage(['INPUT_UPDATE', 'INPUT_REFRESH']);
				this.props.router.navigate('/share/automate/detail/' + id);
			});
		}

	}

	refreshInput(inputId) {
		this.props.refreshInput(inputId);
	}

	render() {
		let buttonLabel = '',
			routes = null;

		// if view type is null, the user store hasn't come back from the server
		// wait for the type to come back to avoid the simple -> advanced flash
		if (this.props.app.flags.routeViewType === null) {
			return null;
		}

		if (parseInt(this.props.app.flags.routeViewType, 10) === this.props.app.config.constants.ROUTE_VIEW_ADVANCED) {
			buttonLabel = "Add a Route";
		} else if (parseInt(this.props.app.flags.routeViewType, 10) === this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
			buttonLabel = "New Automation";
		}

		routes = (this.props.automatedRoutes.filteredList.length) ? this.props.automatedRoutes.filteredList : this.props.automatedRoutes.list;

		return (
			<div>
				<ul className="dlvr-list-component">
					{routes.map((route) => {
						let item = null,
							messages = this.props.getAppMessages(['ROUTE_CREATE', 'INPUT_REFRESH', 'INPUT_UPDATE']),
							errors = null,
							showDetail = (this.state.selectedRoute == route.id) ? true : false;

						// TODO: get errors

						if (this.props.app.flags.routeViewType == this.props.app.config.constants.ROUTE_VIEW_ADVANCED) {
							item = (
								<AdvancedRouteItem
									{...this.props}
									key={route.id}
									detailHandler={this.showDetailForRoute}
									route={route}
									routeHandler={this.props.router}
									newRouteInfo={this.props.newRouteInfo}
									showDetail={showDetail}
									messages={messages}
									inputRefreshHandler={this.refreshInput}
									recordPath={this.props.recordPath} />
							);
						} else if (this.props.app.flags.routeViewType == this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
							item = (
								<SimpleRouteItem
									{...this.props}
									key={route.id}
									detailHandler={this.showDetailForRoute}
									route={route}
									newRouteInfo={this.props.newRouteInfo}
									showDetail={showDetail}
									messages={messages}
									inputRefreshHandler={this.refreshInput}
									recordPath={this.props.recordPath} />
							);
						}

						return item;
					})}
				</ul>
				<Breakpoint desktop only>
					<ListActionButton
						action={this.props.newRouteHandler}
						buttonLabel={buttonLabel} />
				</Breakpoint>
			</div>
		);
	}
};

RouteListComponent.propTypes = {
	newRouteInfo: PropTypes.object.isRequired,
	recordPath: PropTypes.func,
	newRouteHandler: PropTypes.func
};

RouteListComponent.defaultProps = {
	newRouteInfo: {},
	recordPath: () => {},
	newRouteHandler: () => {}
};

export default RouteListComponent;
